import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "font-bold tracking-wider leading-tight text-2xl mt-0 capitalize" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg border-b border-l border-r border-theme-green rounded-t-none" }
const _hoisted_8 = { class: "flex xl:flex-row flex-col gap-3 items-start mb-3" }
const _hoisted_9 = { class: "w-full xl:w-1/2" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "w-full xl:w-1/2" }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "flex xl:flex-row flex-col gap-3 items-start mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "w-full xl:w-1/2"
}
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "flex xl:flex-row flex-col gap-3 mb-3" }
const _hoisted_18 = { class: "w-full xl:w-1/2" }
const _hoisted_19 = { class: "flex items-center cursor-pointer xl:mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.form.processor.value ? _ctx.form.processor.value : 'Add New Terminal'), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addNew()), ["prevent"])),
              class: "h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase"
            }, " SAVE "),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args))),
              class: "cursor-pointer rounded-md text-white py-2 pl-1 hover:opacity-70"
            }, "CLOSE")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass('input-wrapper ' + (_ctx.form.processor.error_type))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name:", -1)),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateFields(['processor']))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.processor.value) = $event)),
                class: "block rounded bg-gray-black w-full"
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("option", {
                  disabled: "",
                  value: ""
                }, "--Select--", -1),
                _createElementVNode("option", { value: "moneris" }, "Moneris", -1),
                _createElementVNode("option", { value: "clover" }, "Clover", -1)
              ]))], 544), [
                [_vModelSelect, _ctx.form.processor.value]
              ]),
              (_ctx.form.processor.error_message)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "field-error label-text mt-1",
                    textContent: _toDisplayString(_ctx.form.processor.error_message)
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass('input-wrapper ' + (_ctx.form.terminalId.error_type))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs mb-1" }, "Terminal ID:", -1)),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Terminal id",
                onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFields(['terminalId']))),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.terminalId.value) = $event)),
                class: "block rounded bg-gray-black w-full",
                type: "text"
              }, null, 544), [
                [_vModelText, _ctx.form.terminalId.value]
              ]),
              (_ctx.form.terminalId.error_message)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "field-error label-text mt-1",
                    textContent: _toDisplayString(_ctx.form.terminalId.error_message)
                  }, null, 8, _hoisted_12))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.form.processor.value==='clover')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper ' + (_ctx.form.merchantId.error_type))
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs mb-1" }, "Merchant ID:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Merchant ID",
                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFields(['merchantId']))),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.merchantId.value) = $event)),
                    class: "block rounded bg-gray-black w-full",
                    type: "text"
                  }, null, 544), [
                    [_vModelText, _ctx.form.merchantId.value]
                  ]),
                  (_ctx.form.merchantId.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.merchantId.error_message)
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-xs mb-1 mt-0" }, "Status:", -1)),
                _createElementVNode("label", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.active) = $event)),
                    class: "hidden peer"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.active]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                  }, null, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.active ? 'text-theme-green' : 'text-[#F53333]'])
                  }, _toDisplayString(_ctx.form.active ? 'ON' : 'OFF'), 3)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}